export const body = {
    border: "1px solid black",
    padding: "10px"
};

export const body_withCursor = {
    border: "1px solid black",
    padding: "10px",
    cursor: "pointer"
};

export const bottomBox = {
    border: "1px solid black",
    textAlign: "center"
};

export const image = {
    height: "150px",
    width: "150px",
    border: "1px solid black"
};

export const columnRight = {
    textAlign: "right"
};

export const customTitle = {
    textDecoration: "underline"
};

export const redText = {
    color: "red"
};

export const repaidItem_columnRight = {
    textAlign: "right"
};
